<template>
    <section class="blockquote container margin-both-xl">
        <div class="html-content">
            <blockquote :author="data.author">
                <p v-html="data.quoted_text" />
                <em v-html="data.author" v-if="data.author"/>
            </blockquote>
        </div>
    </section>
</template>

<script>

export default {
    name: 'blockqoute',
    props: ['data'],
    computed:{},
    components:{},
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.blockquote{
    width: 100%;
    blockquote{
        @include fluid-type($smallResText, $wideResText, 22px, 35px);
        padding: 50px 100px;
        @include mquery($tablet){
            padding: 35px 75px;
        }
        @include mquery($phone){
            margin: 25px 0px;
            padding: 25px 35px;
        }
    }
}
</style>